const store = {
  debug: true,
  state: {},
};

export default store;
